import React, { useState } from 'react'

import { tx } from '@twind/core'

type Company = {
  id: string
  name: string
}

type CompanyPropType = {
  className?: string
  companies: Company[]
  currentlySelectedCompanies?: string[]
  onChangeValue?: (_value: string[]) => void
  numberOfCompaniesToShowInitially?: number
}

const CompanyFilter = (props: CompanyPropType) => {
  const {
    companies,
    className = '',
    currentlySelectedCompanies,
    onChangeValue,
    numberOfCompaniesToShowInitially = 5
  } = props
  const [showMore, setShowMore] = useState<boolean>(true)
  const loadCount = showMore
    ? numberOfCompaniesToShowInitially
    : companies.length

  const handleOnClick = (item: string, isSelected: boolean | undefined) => {
    if (!onChangeValue || typeof currentlySelectedCompanies === 'undefined')
      return

    if (isSelected && onChangeValue)
      onChangeValue(currentlySelectedCompanies.filter((el) => el !== item))
    else {
      onChangeValue([...currentlySelectedCompanies, item])
    }
  }

  return (
    <>
      <div className="flex gap-3 flex-wrap">
        {companies.slice(0, loadCount).map((company) => {
          const isSelected =
            currentlySelectedCompanies &&
            currentlySelectedCompanies.includes(company.id)
          return (
            <span
              key={company.id}
              onClick={() => handleOnClick(company.id, isSelected)}
              className={tx(
                isSelected && 'bg-zinc-600 border-zinc-400',
                'text-sm capitalize border-1 border-zinc-600 rounded-full transition-all',
                className
              )}>
              {company.name}
            </span>
          )
        })}
      </div>
      {companies.length > numberOfCompaniesToShowInitially && (
        <div
          onClick={() => setShowMore(!showMore)}
          className="py-2 text-sm cursor-pointer select-none hover:underline">
          {showMore ? 'Show more' : 'Show less'}
        </div>
      )}
    </>
  )
}

export default CompanyFilter
